declare namespace $ {

	type $mol_button_minor__sub_shm_hitalama_map_widget_float_notebook_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_map_page_contextmenu__item_ids_top_shm_hitalama_map_widget_float_notebook_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['item_ids_top'] >
	>
	type $shm_hitalama_map_page_contextmenu__item_ids_shm_hitalama_map_widget_float_notebook_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['item_ids'] >
	>
	type $shm_hitalama_map_page_contextmenu__Map_page_shm_hitalama_map_widget_float_notebook_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['Map_page'] >
	>
	type $shm_hitalama_map_page_contextmenu__contextmenu_real_pos_shm_hitalama_map_widget_float_notebook_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['contextmenu_real_pos'] >
	>
	type $shm_hitalama_map_widget_float_notebook_pop_over__align_shm_hitalama_map_widget_float_notebook_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook_pop_over['align'] >
	>
	type $shm_hitalama_map_widget_float_notebook_pop_over__Anchor_shm_hitalama_map_widget_float_notebook_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook['Add_widget_anchor'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook_pop_over['Anchor'] >
	>
	type $shm_hitalama_map_widget_float_notebook_pop_over__bubble_content_shm_hitalama_map_widget_float_notebook_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook_pop_over['bubble_content'] >
	>
	type $mol_view__minimal_width_shm_hitalama_map_widget_float_notebook_9 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_view['minimal_width'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_notebook_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook['widget_controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_notebook_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_notebook_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook['widget_cut'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_notebook_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_notebook_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_notebook_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_notebook_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_notebook extends $shm_hitalama_map_widget_float {
		Add_widget_icon( id: any): $mol_icon_plus
		Add_widget_anchor( id: any): $mol_button_minor
		Add_widget_menu( id: any): $shm_hitalama_map_page_contextmenu
		Add( id: any): $shm_hitalama_map_widget_float_notebook_pop_over
		widget_controls( id: any): readonly(any)[]
		Widget_controls( id: any): $mol_view
		widget_cut( id: any, next?: any ): any
		Widget_delete_icon( id: any): $mol_icon_trash_can
		Widget_delete( id: any): $mol_button_minor
		Item_row( id: any): $mol_view
		Item( id: any): $mol_view
		items( ): readonly(any)[]
		List( ): $mol_view
		controls( ): readonly(any)[]
		add_before( id: any): any
	}
	
	export class $shm_hitalama_map_widget_float_notebook_pop_over extends $mol_pop_over {
	}
	
}

//# sourceMappingURL=notebook.view.tree.d.ts.map